/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedStatusRouteImport } from './routes/_authed/status'
import { Route as AuthedSettingsRouteImport } from './routes/_authed/settings'
import { Route as AuthedDashboardRouteImport } from './routes/_authed/dashboard'
import { Route as AuthedAuditLogsRouteImport } from './routes/_authed/audit-logs'
import { Route as AuthedUsersIndexRouteImport } from './routes/_authed/users/index'
import { Route as AuthedSitesIndexRouteImport } from './routes/_authed/sites/index'
import { Route as AuthedMarketplaceIndexRouteImport } from './routes/_authed/marketplace/index'
import { Route as AuthedBillingIndexRouteImport } from './routes/_authed/billing/index'
import { Route as AuthedUsersUserIdRouteImport } from './routes/_authed/users/$userId'
import { Route as AuthedSitesSiteIdRouteImport } from './routes/_authed/sites/$siteId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedStatusRoute = AuthedStatusRouteImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsRoute = AuthedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDashboardRoute = AuthedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAuditLogsRoute = AuthedAuditLogsRouteImport.update({
  id: '/audit-logs',
  path: '/audit-logs',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedUsersIndexRoute = AuthedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSitesIndexRoute = AuthedSitesIndexRouteImport.update({
  id: '/sites/',
  path: '/sites/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMarketplaceIndexRoute = AuthedMarketplaceIndexRouteImport.update({
  id: '/marketplace/',
  path: '/marketplace/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedBillingIndexRoute = AuthedBillingIndexRouteImport.update({
  id: '/billing/',
  path: '/billing/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedUsersUserIdRoute = AuthedUsersUserIdRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSitesSiteIdRoute = AuthedSitesSiteIdRouteImport.update({
  id: '/sites/$siteId',
  path: '/sites/$siteId',
  getParentRoute: () => AuthedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/login': typeof LoginRoute
  '/audit-logs': typeof AuthedAuditLogsRoute
  '/dashboard': typeof AuthedDashboardRoute
  '/settings': typeof AuthedSettingsRoute
  '/status': typeof AuthedStatusRoute
  '/sites/$siteId': typeof AuthedSitesSiteIdRoute
  '/users/$userId': typeof AuthedUsersUserIdRoute
  '/billing/': typeof AuthedBillingIndexRoute
  '/marketplace/': typeof AuthedMarketplaceIndexRoute
  '/sites/': typeof AuthedSitesIndexRoute
  '/users/': typeof AuthedUsersIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/audit-logs': typeof AuthedAuditLogsRoute
  '/dashboard': typeof AuthedDashboardRoute
  '/settings': typeof AuthedSettingsRoute
  '/status': typeof AuthedStatusRoute
  '/': typeof AuthedIndexRoute
  '/sites/$siteId': typeof AuthedSitesSiteIdRoute
  '/users/$userId': typeof AuthedUsersUserIdRoute
  '/billing': typeof AuthedBillingIndexRoute
  '/marketplace': typeof AuthedMarketplaceIndexRoute
  '/sites': typeof AuthedSitesIndexRoute
  '/users': typeof AuthedUsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authed/audit-logs': typeof AuthedAuditLogsRoute
  '/_authed/dashboard': typeof AuthedDashboardRoute
  '/_authed/settings': typeof AuthedSettingsRoute
  '/_authed/status': typeof AuthedStatusRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/sites/$siteId': typeof AuthedSitesSiteIdRoute
  '/_authed/users/$userId': typeof AuthedUsersUserIdRoute
  '/_authed/billing/': typeof AuthedBillingIndexRoute
  '/_authed/marketplace/': typeof AuthedMarketplaceIndexRoute
  '/_authed/sites/': typeof AuthedSitesIndexRoute
  '/_authed/users/': typeof AuthedUsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/audit-logs'
    | '/dashboard'
    | '/settings'
    | '/status'
    | '/sites/$siteId'
    | '/users/$userId'
    | '/billing/'
    | '/marketplace/'
    | '/sites/'
    | '/users/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/audit-logs'
    | '/dashboard'
    | '/settings'
    | '/status'
    | '/'
    | '/sites/$siteId'
    | '/users/$userId'
    | '/billing'
    | '/marketplace'
    | '/sites'
    | '/users'
  id:
    | '__root__'
    | '/_authed'
    | '/login'
    | '/_authed/audit-logs'
    | '/_authed/dashboard'
    | '/_authed/settings'
    | '/_authed/status'
    | '/_authed/'
    | '/_authed/sites/$siteId'
    | '/_authed/users/$userId'
    | '/_authed/billing/'
    | '/_authed/marketplace/'
    | '/_authed/sites/'
    | '/_authed/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/status': {
      id: '/_authed/status'
      path: '/status'
      fullPath: '/status'
      preLoaderRoute: typeof AuthedStatusRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings': {
      id: '/_authed/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthedSettingsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/dashboard': {
      id: '/_authed/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthedDashboardRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/audit-logs': {
      id: '/_authed/audit-logs'
      path: '/audit-logs'
      fullPath: '/audit-logs'
      preLoaderRoute: typeof AuthedAuditLogsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/users/': {
      id: '/_authed/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthedUsersIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/sites/': {
      id: '/_authed/sites/'
      path: '/sites'
      fullPath: '/sites/'
      preLoaderRoute: typeof AuthedSitesIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/marketplace/': {
      id: '/_authed/marketplace/'
      path: '/marketplace'
      fullPath: '/marketplace/'
      preLoaderRoute: typeof AuthedMarketplaceIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/billing/': {
      id: '/_authed/billing/'
      path: '/billing'
      fullPath: '/billing/'
      preLoaderRoute: typeof AuthedBillingIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/users/$userId': {
      id: '/_authed/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof AuthedUsersUserIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/sites/$siteId': {
      id: '/_authed/sites/$siteId'
      path: '/sites/$siteId'
      fullPath: '/sites/$siteId'
      preLoaderRoute: typeof AuthedSitesSiteIdRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedAuditLogsRoute: typeof AuthedAuditLogsRoute
  AuthedDashboardRoute: typeof AuthedDashboardRoute
  AuthedSettingsRoute: typeof AuthedSettingsRoute
  AuthedStatusRoute: typeof AuthedStatusRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedSitesSiteIdRoute: typeof AuthedSitesSiteIdRoute
  AuthedUsersUserIdRoute: typeof AuthedUsersUserIdRoute
  AuthedBillingIndexRoute: typeof AuthedBillingIndexRoute
  AuthedMarketplaceIndexRoute: typeof AuthedMarketplaceIndexRoute
  AuthedSitesIndexRoute: typeof AuthedSitesIndexRoute
  AuthedUsersIndexRoute: typeof AuthedUsersIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAuditLogsRoute: AuthedAuditLogsRoute,
  AuthedDashboardRoute: AuthedDashboardRoute,
  AuthedSettingsRoute: AuthedSettingsRoute,
  AuthedStatusRoute: AuthedStatusRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedSitesSiteIdRoute: AuthedSitesSiteIdRoute,
  AuthedUsersUserIdRoute: AuthedUsersUserIdRoute,
  AuthedBillingIndexRoute: AuthedBillingIndexRoute,
  AuthedMarketplaceIndexRoute: AuthedMarketplaceIndexRoute,
  AuthedSitesIndexRoute: AuthedSitesIndexRoute,
  AuthedUsersIndexRoute: AuthedUsersIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
